/** Local WhatsApp bubble surfaces. Copied for marketing; do not import web-vendor. */
export const chatChrome = {
  outgoing: 'rounded-2xl rounded-tr-sm bg-[#d9fdd3] text-[#111b21]',
  incoming: 'rounded-2xl rounded-tl-sm bg-white text-[#111b21]',
  shadow: 'shadow-[0_1px_0.5px_rgba(11,20,26,0.13)]',
} as const;
